import axios from 'axios'
const BASE_URL = `${process.env.REACT_APP_API_URL}/api/v1/`;

export const getData = (url, headers, customBaseUrl = BASE_URL) => {
    return axios.get(`${customBaseUrl}${url}`, headers)
}

export const postData = (url, data, header, customBaseUrl = BASE_URL) => {
    return axios.post(`${customBaseUrl}${url}`, data, header)
}

export const patchData = (url, data, header, customBaseUrl = BASE_URL) => {
    return axios.patch(`${customBaseUrl}${url}`, data, header)
}

export const deleteData = (url, header, customBaseUrl = BASE_URL) => {
    return axios.delete(`${customBaseUrl}${url}`, header)
}

export const putData = (url, data, header, customBaseUrl = BASE_URL) => {
    return axios.put(`${customBaseUrl}${url}`, data, header)
}


